import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

// react-routers components
import { Link } from "react-router-dom";

// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import Switch from "@mui/material/Switch";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";

import MDActionConfigurator from "components/MDActionConfigurator";

import { supplierUpdating } from "actions/supplierActions";
import { getProfile } from "actions/userActions";

function SupplierInfoCard({
  title,
  active,
  info,
  currentInfo,
  id,
  social,
  mode,
  action,
  shadow,
}) {
  const configuratorRef = useRef(null);
  const dispatch = useDispatch();
  const [currentState, setCurrentState] = useState("");
  const [currentData, setCurrentData] = useState({
    _id: "",
    supplierName: "",
    supplierLogo: "",
    supplierEmail: "",
    supplierPhone: "",
    supplierRelationshipManagerPhone: "",
    supplierRelationshipManagerEmail: "",
    supplierUnderWriterPhone: "",
    supplierUnderWriterEmail: "",
    supplierAddress: "",
    // active: false,
    created_at: "",
  });
  const labels = [];
  const values = [];
  const { socialMediaColors } = colors;
  const { size } = typography;

  const getMe = useSelector((state) => state.getMe);
  const { me } = getMe;

  useEffect(() => {
    // if (me?.length === 0) {
    dispatch(getProfile());
    // }
  }, [dispatch]);

  const handleToggleBackdrop = (item, state) => {
    setCurrentData(item);
    setCurrentState(state);
    if (configuratorRef.current) {
      configuratorRef.current.handleToggleConfigurator();
    }
  };

  const handleSubmitSupplier = (e) => {
    dispatch(supplierUpdating(id, e));

    handleToggleBackdrop({}, "");
  };

  // Convert this form `objectKey` of the object key in to this `object key`
  Object.keys(info).forEach((el) => {
    if (el.match(/[A-Z\s]+/)) {
      const uppercaseLetter = Array.from(el).find((i) => i.match(/[A-Z]+/));
      const newElement = el.replace(
        uppercaseLetter,
        ` ${uppercaseLetter.toLowerCase()}`
      );

      labels.push(newElement);
    } else {
      labels.push(el);
    }
  });

  // Push the object values into the values array
  Object.values(info).forEach((el) => values.push(el));

  // Render the card info items
  const renderItems = labels.map((label, key) => (
    <MDBox key={label} display="flex" py={1} pr={2}>
      <MDTypography
        variant="button"
        fontWeight="bold"
        textTransform="capitalize"
        sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
      >
        {label}: &nbsp;
      </MDTypography>
      <MDTypography
        variant="button"
        fontWeight="regular"
        sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
      >
        &nbsp;{values[key]}
      </MDTypography>
    </MDBox>
  ));

  // Render the card social media icons
  // const renderSocial = social.map(({ link, icon, color }) => (
  //   <MDBox
  //     key={color}
  //     component="a"
  //     href={link}
  //     target="_blank"
  //     rel="noreferrer"
  //     fontSize={size.lg}
  //     color={socialMediaColors[color].main}
  //     pr={1}
  //     pl={0.5}
  //     lineHeight={1}
  //   >
  //     {icon}
  //   </MDBox>
  // ));

  return (
    <>
      <MDBox>
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          pt={2}
          px={2}
        >
          <MDTypography
            variant="h6"
            fontWeight="medium"
            textTransform="capitalize"
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
          >
            {title}
          </MDTypography>
          {(me?.role === "super_admin" || me?.role === "admin") && (
            <MDTypography
              component={Link}
              to={action.route}
              variant="body2"
              sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
              onClick={() => handleToggleBackdrop(currentInfo, "edit")}
            >
              <Tooltip title={action.tooltip} placement="top">
                <Icon>edit</Icon>
              </Tooltip>
            </MDTypography>
          )}
        </MDBox>
        <MDBox p={2}>
          {/* <MDBox mb={2} lineHeight={1}>
            <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
              <MDBox mt={0.5}>
                <Switch
                  checked={active}
                  onChange={() => console.log("activity toggle")}
                />
              </MDBox>
              <MDBox width="80%" ml={0.5}>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                >
                  Supplier Account is {active ? " Active" : " Inactive"}
                </MDTypography>
              </MDBox>
            </MDBox>
          </MDBox> */}
          <MDBox opacity={0.3}>
            <Divider />
          </MDBox>
          <MDBox>
            {renderItems}
            {/* <MDBox display="flex" py={1} pr={2}>
              <MDTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                social: &nbsp;
              </MDTypography>
              {renderSocial}
            </MDBox> */}
          </MDBox>
        </MDBox>
      </MDBox>

      <MDActionConfigurator
        ref={configuratorRef}
        title="Configure Supplier"
        onCompleteConfig={handleSubmitSupplier}
        data={[
          {
            keyType: "_id",
            valueType: currentData?._id,
          },
          {
            labelType: "Supplier Name",
            placeholderType: "Enter Supplier Name",
            dataType: "text",
            keyType: "supplierName",
            valueType: currentData?.supplierName,
          },
          {
            labelType: "Supplier Email",
            placeholderType: "Enter Supplier Email",
            dataType: "email",
            keyType: "supplierEmail",
            valueType: currentData?.supplierEmail,
          },
          {
            labelType: "Supplier Phone",
            placeholderType: "Enter Supplier Phone",
            dataType: "phone",
            keyType: "supplierPhone",
            valueType: currentData?.supplierPhone,
          },
          {
            labelType: "Supplier Relationship Manager Phone",
            placeholderType: "Enter Supplier Relationship Manager Phone",
            dataType: "phone",
            keyType: "supplierRelationshipManagerPhone",
            valueType: currentData?.supplierRelationshipManagerPhone,
          },
          {
            labelType: "Supplier Relationship Manager Email",
            placeholderType: "Enter Supplier Relationship Manager Email",
            dataType: "email",
            keyType: "supplierRelationshipManagerEmail",
            valueType: currentData?.supplierRelationshipManagerEmail,
          },
          {
            labelType: "Supplier UnderWriter Phone",
            placeholderType: "Enter Supplier UnderWriter Phone",
            dataType: "phone",
            keyType: "supplierUnderWriterPhone",
            valueType: currentData?.supplierUnderWriterPhone,
          },
          {
            labelType: "Supplier UnderWriter Email",
            placeholderType: "Enter Supplier UnderWriter Email",
            dataType: "email",
            keyType: "supplierUnderWriterEmail",
            valueType: currentData?.supplierUnderWriterEmail,
          },
          {
            labelType: "Supplier Address",
            placeholderType: "Enter Supplier Address",
            dataType: "text",
            keyType: "supplierAddress",
            valueType: currentData?.supplierAddress,
          },
          {
            labelType: "Supplier Logo",
            placeholderType: "Enter Supplier Logo",
            dataType: "image",
            keyType: "supplierLogo",
            valueType: currentData?.supplierLogo,
          },
          // {
          //   labelType: "Active",
          //   placeholderType: "Active",
          //   dataType: "active",
          //   keyType: "active",
          //   valueType: currentData?.active,
          // },
        ]}
        state={currentState}
      />
    </>
  );
}

// Setting default props for the SupplierInfoCard
SupplierInfoCard.defaultProps = {
  shadow: true,
};

// Typechecking props for the SupplierInfoCard
SupplierInfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  info: PropTypes.objectOf(PropTypes.string).isRequired,
  // social: PropTypes.arrayOf(PropTypes.object).isRequired,
  action: PropTypes.shape({
    route: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired,
  }).isRequired,
  shadow: PropTypes.bool,
};

export default SupplierInfoCard;
